import React from 'react';
// import * as pt from 'prop-types';
import _ from 'underscore';
import { Table } from 'react-bootstrap';
import events from './manifest';

function noRecords (props) {
    return props.analytics.data.meta === '0 records found';
}

export default function AssetsTable (props) {
    if (noRecords(props)) return null;

    var assetData = _(props.vast.data.campaignAssets.map(function (asset) {
        return [
            asset.name,
            asset.weight,
            props.analytics.data.assetTotalCounts[asset.assetID] || 0,
            props.analytics.data.assetTotalClicks[asset.assetID] || 0,
            (props.analytics.data.assetTotalCounts &&
                props.analytics.data.assetTotalCounts[asset.assetID]) ?
                ((props.analytics.data.assetTotalClicks[asset.assetID] /
                    props.analytics.data.assetTotalCounts[asset.assetID]) *
                    100).toFixed(2) + ' %' : 'n/a'
        ];
    })).sortBy(function (row) {
        var sorts = ['asset', 'weight', 'views', 'clicks', 'clickRate'];
        return row[sorts.indexOf(props.sortTableBy)];
    });

    const headings = [
        ['Asset', 'asset'],
        ['Weight', 'weight'],
        ['Views', 'views'],
        ['Clicks', 'clicks'],
        ['Click rate', 'clickRate']
    ];

    if (props.sortTableAsc) assetData.reverse();

    return (<div className="callout row">
        <div className="col-sm-12">
            <Table bordered condensed hover>
                <thead>
                    <tr>
                        {headings.map(function (heading, index) {

                            return (<th key={index}>
                                <button
                                    type="button"
                                    className={'btn btn-link' +
                                        (props.sortTableBy === heading[1] ?
                                            ' active-heading' :
                                            '')
                                    }

                                    style={{
                                        padding: 0
                                    }}

                                    onClick={_.compose(
                                        props.push,
                                        events.sortTable,
                                        function (ev) {
                                            ev.preventDefault();
                                            return heading[1];
                                        }
                                    )}
                                >
                                    {heading[0]}

                                    {props.sortTableBy === heading[1] ?
                                        <span
                                            className={'glyphicon ' +
                                                (props.sortTableAsc ?
                                                'glyphicon-triangle-top' :
                                                'glyphicon-triangle-bottom')
                                            }
                                            style={{
                                                fontSize: '0.8em',
                                                marginLeft: '0.4em'
                                            }}
                                            aria-hidden="true">
                                        </span> :
                                        ''
                                    }
                                </button>
                            </th>);
                        })}
                    </tr>
                </thead>

                <tbody>
                    {assetData.map(function (asset, index) {
                        return (<tr key={index}>
                            {(asset.length) ? asset.map(function (p, pi) {
                                return (<td key={pi}>
                                    {p}
                                </td>);
                            }, this) : null}
                        </tr>);
                    })}
                </tbody>

            </Table>
        </div>
    </div>);
}

AssetsTable.propTypes = {};
